<!-- 
Favourite indicator.

This is the little clickable loveheart that allows users to flag (or un-flag) a provider.
-->
<template>
  <span v-if="provider">
    <v-progress-circular 
      v-if="saving" 
      size="24" width="6" class="mr-2 grey--text text--lighten-1"
      indeterminate
    />
    <v-icon v-else-if="loading" class="pb-1 mr-2 grey--text text--lighten-3">favorite_border</v-icon>
    <v-tooltip v-if="provider.favourite && !busy" bottom>
      <v-icon 
        slot="activator" 
        :color="color" :style="style" 
        class="pb-1 mr-2" 
        @click="toggle"
      >{{ icon }}</v-icon>
      <span>{{ caption }}</span>
    </v-tooltip>
    <v-tooltip v-if="!provider.favourite && canEdit && !busy" bottom>
      <v-icon 
        slot="activator"
        :color="color" :style="style" 
        class="pb-1 mr-2" 
        @click="toggle"
      >{{ icon }}</v-icon>
      <span>{{ caption }}</span>
    </v-tooltip>
  </span>
</template>

<script>
import * as claim from "@/store/claim-types";
import * as action from "@/store/levy-collection-providers/action-types";

export default {
  props: {
    provider: {
      required: true,
      type: Object
    }
  },
  computed: {
    canEdit() {
      return this.$store.getters.claims.includes(claim.LCP_TASK_FAVOURITE);
    },
    caption() {
      if (this.provider.favourite) {
        return `This provider has been marked as a favourite.${this.canEdit ? " Click to unmark." : ""}`;
      } else {
        return "Click to mark this provider as a favourite.";
      }
    },
    icon() {
      return this.provider.favourite ? "favorite" : "favorite_border";
    },
    color() {
      return this.provider.favourite ? "pink" : "";
    },
    state() {
      return this.$store.state.levyCollectionProviders.task;
    },
    saving() {
      return this.state.processing && (this.state.type == "Unfavourite" || this.state.type == "Favourite");
    },
    loading() {
      return this.$store.state.levyCollectionProviders.view.loading;
    },
    busy() {
      return this.saving || this.loading;
    },
    style() {
      return this.canEdit ? "cursor:pointer;" : "cursor:default;";
    }
  },
  methods: {
    toggle() {
      if (this.canEdit) {
        this.$store.dispatch(action.TASK_RUN, {
          levyCollectionId: this.provider.levyCollectionId,
          providerId: this.provider.providerId,
          type: this.provider.favourite ? "Unfavourite" : "Favourite"
        });
      }
    }
  }
};
</script>
